import React, { useEffect, useState } from "react";
import { GoogleMap, OverlayView } from "@react-google-maps/api";
import {
  FaInfoCircle,
  FaPhone,
  FaCoins,
  FaUser,
  FaTools,
  FaBuilding,
  FaUserAlt,
} from "react-icons/fa";

const mapContainerStyle = {
  width: "100%",
  height: "600px",
};

interface UserLocation {
  lat: number;
  lng: number;
  locationName: string;
  City: string;
  image: string;
  name: string;
  phone: string;
  points: number;
  about: string;
  accountType: string;
}
interface SelectedProvince {
  name: string;
  lat: number;
  lng: number;
  zoom: number;
}
interface Props {
  userLocations: UserLocation[];
  isLoaded: boolean;
  activeTab: string;
  filters: string[];
  handleFilterChange: (type: string) => void;
  selectedProvince?: SelectedProvince | null;
}

// 🎯 دالة تحديد اللون حسب النقاط
const getBorderColor = (points: number): string => {
  if (points <= 500) return "#8BC34A";
  if (points <= 100000) return "#FFC107";
  if (points <= 250000) return "#FF9800";
  if (points <= 500000) return "#f44336";
  return "#6a1b9a";
};

const UserLocationsMap: React.FC<Props> = ({
  userLocations,
  isLoaded,
  activeTab,
  filters,
  handleFilterChange,
  selectedProvince,
}) => {
  const [hoveredUserId, setHoveredUserId] = useState<string | null>(null);
const [map, setMap] = useState<google.maps.Map | null>(null);
  const center = userLocations.length
    ? { lat: userLocations[0].lat, lng: userLocations[0].lng }
    : { lat: 33.3152, lng: 44.3661 };


    useEffect(() => {
  if (!map || !selectedProvince) return;

  map.panTo({
    lat: selectedProvince.lat,
    lng: selectedProvince.lng,
  });

  map.setZoom(selectedProvince.zoom);
}, [map, selectedProvince]);
  const getAccountTypeIcon = (type: string) => {
    console.log("this is account type for : ", type);
    switch (type) {
      case "منصب":
        return <FaTools className="text-[#ff6c30] text-lg" />;
      case "وكيل":
        return <FaBuilding className="text-[#ff6c30] text-lg" />;
      case "مستخدم":
        return <FaUserAlt className="text-[#ff6c30] text-lg" />;
      default:
        return null;
    }
  };
  //0777 507 0193

  return (
    <>
      {activeTab === "locations" && isLoaded && (
        <div className="w-full px-0 mt-4 relative font-[Tajawal]">
          {/* <h2 className="text-lg font-bold text-gray-800 mb-4">
            المواقع المرتبطة بالحساب:
          </h2> */}
          <div className="w-full rounded-xl overflow-hidden shadow-lg border border-gray-200 relative">
           <GoogleMap
  mapContainerStyle={mapContainerStyle}
  center={center}
  zoom={7}
  onLoad={(mapInstance) => setMap(mapInstance)}
  onUnmount={() => setMap(null)}
>
              {userLocations.map((user, index) => (
                <OverlayView
                  key={index}
                  position={{ lat: user.lat, lng: user.lng }}
                  mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                >
                  <div
                    className="group relative"
                    onMouseEnter={() => setHoveredUserId(user.phone)}
                    onMouseLeave={() => setHoveredUserId(null)}
                  >
                    {/* الصورة الدائرية */}
                    <div
                      className="transition-transform duration-200 ease-in-out relative" // ← أضف 'relative' هنا
                      style={{
                        width: "60px",
                        height: "60px",
                        transform:
                          hoveredUserId === user.phone
                            ? "scale(1.2)"
                            : "scale(1)",
                        borderRadius: "50%",
                        overflow: "hidden",
                        border: `4px solid ${getBorderColor(user.points)}`,
                        boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                        backgroundColor: "#fff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        src={user.image}
                        alt={user.name}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: "50%",
                        }}
                      />

                      {/* ✅ الأيقونة تُعرض في الزاوية السفلى اليمنى */}
                    </div>
                    <div className="absolute bottom-[-6px] right-[-6px] bg-[#262d34] rounded-full p-[4px] shadow-md">
                      {getAccountTypeIcon(user.accountType)}
                    </div>
                    {/* الكارت العائم عند التمرير */}
                    {hoveredUserId === user.phone && (
                      <div
                        className={`
                        absolute z-50 bottom-[75px] right-full mr-3
                        border border-gray-300 shadow-xl rounded-xl
                        px-4 py-3 text-right w-auto max-w-sm
                        transition-all duration-200 ease-in-out
                        ${
                          hoveredUserId === user.phone
                            ? "opacity-100 scale-100"
                            : "opacity-0 scale-95 pointer-events-none"
                        }
                        font-[Tajawal] bg-[#262d34]
                      `}
                      >
                        <div className="space-y-2 text-xs text-gray-800 text-right">
                          <div className="flex  items-center gap-2">
                            <FaUser className="text-orange-500 text-lg" />
                            <span className="text-white   text-xs text-right  whitespace-nowrap">
                              اســـم الــــتقـــني:
                            </span>
                            <span className="text-white   text-xs text-right  whitespace-nowrap">
                              {user.name}
                            </span>
                          </div>

                          <div className="flex items-center gap-2">
                            <FaPhone className="text-orange-500 text-lg" />
                            <span className="text-white  text-xs text-right  whitespace-nowrap">
                              رقــــم الهـــاتف:
                            </span>
                            <span className="text-white   text-xs text-right  whitespace-nowrap">
                              {user.phone}
                            </span>
                          </div>

                          <div className="flex  items-center gap-2">
                            <FaCoins className="text-orange-500 text-lg" />
                            <span className="text-white   text-xs text-right  whitespace-nowrap">
                              مجموع النقاط:
                            </span>
                            <span className="text-white   text-xs text-right  whitespace-nowrap">
                              {user.points.toLocaleString("en-US")} نقطة
                            </span>
                          </div>

                          <div className="flex items-center gap-2">
                            <FaInfoCircle className="text-orange-500 text-lg" />
                            <span className="text-white   text-xs text-right  whitespace-nowrap">
                              المعلومات:
                            </span>
                            <span className="text-white   text-xs text-right  whitespace-nowrap">
                              {user.about.split(" ").slice(0, 5).join(" ") +
                                (user.about.split(" ").length > 10
                                  ? "..."
                                  : "")}
                            </span>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </OverlayView>
              ))}
            </GoogleMap>

            {/* الدليل */}
            <div
              className="absolute bottom-4 left-4  bg-[#262d34]  rounded-lg p-4 shadow-md border border-gray-300 text-sm space-y-2 z-10"
              style={{ width: "220px", fontFamily: "Tajawal" }}
            >
              <p className="font-bold text-white mb-1"> معلومات النقاط:</p>
              {[
                { color: "#8BC34A", label: "0 - 500 نقطة" },
                { color: "#FFC107", label: "501 - 5,000" },
                { color: "#FF9800", label: "100,001 - 250,000" },
                { color: "#f44336", label: "250,001 - 500,000" },
                { color: "#6a1b9a", label: "أكثر من 500,000" },
              ].map((item, i) => (
                <div className="flex items-center gap-2" key={i}>
                  <span
                    className="w-4 h-4 rounded-full inline-block"
                    style={{ backgroundColor: item.color }}
                  ></span>
                  <span className=" text-white">{item.label}</span>
                </div>
              ))}

              <div className="mt-4 space-y-2">
                <p className="font-bold text-white mb-1">تصفية حسب النوع:</p>
                {["منصب", "وكيل", "مستخدم"].map((type) => (
                  <label
                    key={type}
                    className="flex items-center gap-2 text-white text-xs"
                  >
                    <input
                      type="checkbox"
                      checked={filters.includes(type)}
                      onChange={() => handleFilterChange(type)}
                      className="accent-orange-500"
                    />
                    {type}
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default UserLocationsMap;
